/**
 * @generated SignedSource<<9ec47a7b9b469116973776277a240b91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateCityInput = {
  id: string;
  name?: string | null;
};
export type CityEditFormMutation$variables = {
  input: UpdateCityInput;
};
export type CityEditFormMutation$data = {
  readonly updateCity: {
    readonly " $fragmentSpreads": FragmentRefs<"CityEditForm_city" | "CitySidebar_city">;
  };
};
export type CityEditFormMutation = {
  response: CityEditFormMutation$data;
  variables: CityEditFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CityEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "City",
        "kind": "LinkedField",
        "name": "updateCity",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CityEditForm_city"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CitySidebar_city"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CityEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "City",
        "kind": "LinkedField",
        "name": "updateCity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1d6a3bb8a0d6f6a074aaed0b5cdea4c8",
    "id": null,
    "metadata": {},
    "name": "CityEditFormMutation",
    "operationKind": "mutation",
    "text": "mutation CityEditFormMutation(\n  $input: UpdateCityInput!\n) {\n  updateCity(input: $input) {\n    ...CityEditForm_city\n    ...CitySidebar_city\n    id\n  }\n}\n\nfragment CityEditForm_city on City {\n  id\n  name\n}\n\nfragment CitySidebar_city on City {\n  ...EntitySidebar_entity\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n"
  }
};
})();

(node as any).hash = "31aa7970a4e0c27bcec0b602751c240f";

export default node;
